import type { OnboardingTaskKey } from '@awork/features/onboarding/models/types'

export class OnboardingTaskProgress {
  id: string
  key: OnboardingTaskKey
  isDone: boolean
  completedOn?: Date

  constructor(data: Partial<OnboardingTaskProgress>) {
    Object.assign(this, data)
    this.completedOn = data.completedOn ? new Date(data.completedOn) : undefined
  }
}
